import type { ConversationNodeIVRMenu } from 'lib-shared-types-api';

type Props = {
  node: ConversationNodeIVRMenu;
};

export function RoutedThroughIVRMenu({ node }: Props): JSX.Element {
  return (
    <>
      IVR ·{' '}
      {node.button ? (
        <>
          Pressed <strong>{node.button}</strong>
        </>
      ) : (
        'No response'
      )}
    </>
  );
}
